module.exports = __webpack_public_path__ + "static/media/4 location melbourne street sidewalk dark wall urban trees parked cars 1280x2276.4c710c52.webp";